'use client';

import { c as _c } from "react/compiler-runtime";
import type { CodeContent } from '@/types/github';
import { PrV2FileTypeIcon } from '../shared/pr-v2-file-type-icon';
import { getFileChangeCounts } from './pr-v2-file-story-metadata-utils';
import { cn } from '@/lib/utils';
type PrV2GroupFileListProps = {
  groupName: string;
  files: CodeContent[];
  activeFilename: string | null;
  onSelectFile: (filename: string) => void;
  className?: string;
};
function getFilename(path: string): string {
  return path.slice(path.lastIndexOf('/') + 1) || path;
}
function PrV2GroupFileListItem(t0) {
  const $ = _c(29);
  const {
    file,
    isActive,
    onSelectFile
  } = t0;
  let t1;
  if ($[0] !== file) {
    t1 = getFileChangeCounts(file);
    $[0] = file;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    additionsCount,
    deletionsCount
  } = t1;
  let t2;
  if ($[2] !== file.filename || $[3] !== onSelectFile) {
    t2 = () => onSelectFile(file.filename);
    $[2] = file.filename;
    $[3] = onSelectFile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onClick = t2;
  const t3 = file.filename;
  const t4 = `pr-v2-group-guide-file-${file.filename}`;
  const t5 = isActive ? "true" : undefined;
  const t6 = isActive ? "border-zinc-700 bg-zinc-900 text-zinc-100" : "border-zinc-800/80 bg-zinc-950/40 text-zinc-300 hover:border-zinc-700 hover:bg-zinc-900/70";
  let t7;
  if ($[5] !== t6) {
    t7 = cn("flex w-full min-w-0 items-center gap-2 rounded-md border px-2.5 py-2 text-left transition-colors", t6);
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== file.filename) {
    t8 = <PrV2FileTypeIcon filename={file.filename} className="size-3.5 shrink-0" />;
    $[7] = file.filename;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== file.filename) {
    t9 = getFilename(file.filename);
    $[9] = file.filename;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t9) {
    t10 = <span className="min-w-0 flex-1 truncate text-[12px] text-zinc-200">{t9}</span>;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== additionsCount) {
    t11 = additionsCount > 0 ? <span className="text-emerald-400">{`+${additionsCount}`}</span> : null;
    $[13] = additionsCount;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== deletionsCount) {
    t12 = deletionsCount > 0 ? <span className="text-rose-400">{`-${deletionsCount}`}</span> : null;
    $[15] = deletionsCount;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t12) {
    t13 = <span className="ml-auto inline-flex shrink-0 items-center gap-1 text-[11px] tabular-nums">{t11}{t12}</span>;
    $[17] = t11;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== file.filename || $[21] !== onClick || $[22] !== t10 || $[23] !== t13 || $[24] !== t4 || $[25] !== t5 || $[26] !== t7 || $[27] !== t8) {
    t14 = <button type="button" data-filename={t3} data-testid={t4} aria-current={t5} onClick={onClick} className={t7}>{t8}{t10}{t13}</button>;
    $[20] = file.filename;
    $[21] = onClick;
    $[22] = t10;
    $[23] = t13;
    $[24] = t4;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}
export function PrV2GroupFileList(t0) {
  const $ = _c(13);
  const {
    groupName,
    files,
    activeFilename,
    onSelectFile,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("space-y-1.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `${groupName} files`;
  let t3;
  if ($[2] !== activeFilename || $[3] !== files || $[4] !== onSelectFile) {
    let t4;
    if ($[6] !== activeFilename || $[7] !== onSelectFile) {
      t4 = file => <PrV2GroupFileListItem key={file.filename} file={file} isActive={activeFilename === file.filename} onSelectFile={onSelectFile} />;
      $[6] = activeFilename;
      $[7] = onSelectFile;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = files.map(t4);
    $[2] = activeFilename;
    $[3] = files;
    $[4] = onSelectFile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <div role="group" className={t1} aria-label={t2}>{t3}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}